import BadgesValueV2 from "../BadgesValueV2";
import FootballBadgeRequirements from "./FootballBadgeRequirements";

export default class FootballBadgesValue extends BadgesValueV2 {
  public requirements: FootballBadgeRequirements =
    new FootballBadgeRequirements();
}
